// FingerprintScanner.js
import React, { useRef, useState } from 'react';
import Webcam from 'react-webcam';

const FingerprintScanner = ({ onCapture }) => {
  const webcamRef = useRef(null);
  const [image, setImage] = useState(null);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImage(imageSrc);
    onCapture({ image: imageSrc });
  };

  return (
    <div className="fingerprint-scanner">
      <div className="scanner-container">
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={{
            width: 300,
            height: 200,
            facingMode: 'environment'
          }}
        />
        <button onClick={capture} className="btn btn-primary mt-2">
          Capture Image
        </button>
      </div>
      {image && (
        <div className="preview mt-3">
          <h5>Captured Image:</h5>
          <img src={image} alt="Captured" className="img-fluid" />
        </div>
      )}
    </div>
  );
};

export default FingerprintScanner;